// Miroir exact de validatePassword() backend (auth.js:41-46).
// Politique : min 8 chars + 1 majuscule + 1 minuscule + 1 chiffre + 1 caractère spécial.

export function validatePassword(password) {
  if (!password || typeof password !== 'string') return false;
  if (password.length < 8) return false;
  return /[A-Z]/.test(password)
    && /[a-z]/.test(password)
    && /[0-9]/.test(password)
    && /[^A-Za-z0-9]/.test(password);
}

// Retourne la liste des règles non satisfaites — pour affichage UX temps réel
// dans la modale ForcePasswordChange. Chaque règle est {key, label, ok}.
export function getPasswordRules(password) {
  const pwd = typeof password === 'string' ? password : '';
  return [
    { key: 'length',  label: 'Au moins 8 caractères',           ok: pwd.length >= 8 },
    { key: 'upper',   label: 'Une majuscule (A-Z)',             ok: /[A-Z]/.test(pwd) },
    { key: 'lower',   label: 'Une minuscule (a-z)',             ok: /[a-z]/.test(pwd) },
    { key: 'digit',   label: 'Un chiffre (0-9)',                ok: /[0-9]/.test(pwd) },
    { key: 'special', label: 'Un caractère spécial (!@#$…)',    ok: /[^A-Za-z0-9]/.test(pwd) },
  ];
}
